import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="row-link"
//
// This is a quick and dirty way to make a table row clickable. I wrote it as
// a replacement for Alpine's `x-on:click="window.location.assign(...)` so we
// can deprecate Alpine. However (and this also applies to Alpine), it's not
// great because it's not accessible. Keyboard navigation doesn't work and
// screen readers won't announce the link.
export default class extends Controller {
  static values = { href: String }

  declare hrefValue: string

  assign: typeof window.location.assign = this.defaultAssign

  connect (): void {
    this.element.addEventListener('click', this.click.bind(this))
    this.element.addEventListener('auxclick', this.click.bind(this))
  }

  click (e: Event) {
    // If the user clicked on a link inside the row, don't do anything so that
    // the link works as expected.
    const target = e.target as HTMLElement
    if (target instanceof HTMLAnchorElement) return
    if (target instanceof HTMLInputElement) return
    if (this.hrefValue === '') return

    // Check if target or any ancestor up to this controller's element has the data-no-row-click attribute
    const closestElement = target.closest('[data-no-row-click], [data-controller="row-link"]')
    if (closestElement?.hasAttribute('data-no-row-click')) return

    if ((e as MouseEvent).metaKey || (e as MouseEvent).ctrlKey || (e as MouseEvent).button === 1) {
      window.open(this.hrefValue, '_blank')
    } else {
      this.assign(this.hrefValue)
    }
  }

  private defaultAssign (url: string | URL) {
    return window.location.assign(url)
  }
}
